/**
 * クレジットカード関連の定数
 */
import React from 'react';

/**
 * 個人情報の取り扱いに関する同意文
 */
export const PERSONAL_INFO_CONSENT = {
  title: '個人情報の取り扱いについて',
  content: {
    introduction: '当社がお客様から収集した以下の個人情報等は、カード発行会社が行う不正利用検知・防止のために、お客様が利用されているカード発行会社へ提供させていただきます。',
    
    collectedInfo: '氏名、電話番号、emailアドレス、インターネット利用環境に関する情報 等',
    
    internationalTransfer: 'お客様が利用されているカード発行会社が外国にある場合、これらの情報は当該発行会社が所属する国に移転される場合があります。当社では、お客様から収集した情報からは、ご利用のカード発行会社及び当該会社が所在する国を特定することができないため、以下の個人情報保護措置に関する情報を把握して、ご提供することはできません。',
    
    unprovidableInfo: [
      '提供先が所在する外国の名称',
      '当該国の個人情報保護制度に関する情報',
      '発行会社の個人情報保護の措置'
    ],
    
    reference: {
      text: 'なお、個人情報保護委員会のホームページ（{link}）では、各国における個人情報保護制度に関する情報について掲載されています。',
      url: 'https://www.ppc.go.jp/'
    },
    
    minorConsent: 'お客様が未成年の場合、親権者または後見人の承諾を得た上で、本サービスを利用するものとします。'
  }
};

/**
 * 個人情報同意コンポーネント
 * クレジットカード登録・変更画面で使用
 */
export const PersonalInfoConsent = () => (
  <div style={{
    marginBottom: '20px',
    padding: '15px',
    backgroundColor: '#f8f9fa',
    borderRadius: '5px',
    border: '1px solid #dee2e6',
    textAlign: 'left',
    fontSize: '13px',
    lineHeight: '1.6'
  }}>
    <h3 style={{ 
      fontSize: '14px', 
      fontWeight: 'bold', 
      marginBottom: '10px',
      color: '#333'
    }}>
      {PERSONAL_INFO_CONSENT.title}
    </h3>
    <p style={{ marginBottom: '10px' }}>
      {PERSONAL_INFO_CONSENT.content.introduction}
    </p>
    <p style={{ marginBottom: '10px', paddingLeft: '15px' }}>
      {PERSONAL_INFO_CONSENT.content.collectedInfo}
    </p>
    <p style={{ marginBottom: '10px' }}>
      {PERSONAL_INFO_CONSENT.content.internationalTransfer}
    </p>
    <ul style={{ marginBottom: '10px', paddingLeft: '30px' }}>
      {PERSONAL_INFO_CONSENT.content.unprovidableInfo.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
    <p style={{ marginBottom: '10px' }} dangerouslySetInnerHTML={{
      __html: PERSONAL_INFO_CONSENT.content.reference.text.replace(
        '{link}',
        `<a href="${PERSONAL_INFO_CONSENT.content.reference.url}" target="_blank" rel="noopener noreferrer" style="color: #007bff">${PERSONAL_INFO_CONSENT.content.reference.url}</a>`
      )
    }} />
    <p style={{ marginBottom: '0' }}>
      {PERSONAL_INFO_CONSENT.content.minorConsent}
    </p>
  </div>
);

/**
 * ボタンテキスト
 */
export const BUTTON_TEXT = {
  register: {
    submitting: '決済処理中...',
    submit: (amount) => `同意して¥${amount.toLocaleString()}を決済しクレジットカードを登録する`
  },
  update: {
    submitting: '更新中...',
    submit: '同意してクレジットカードを更新する'
  }
};

/**
 * エラーメッセージ翻訳マップ
 */
export const ERROR_TRANSLATIONS = {
  'declined': 'クレジットカードが拒否されました。カード情報をご確認ください。',
  'CARD_DECLINED': 'クレジットカードが拒否されました。カード情報をご確認ください。',
  'expired': 'クレジットカードの有効期限が切れています。',
  'CARD_EXPIRED': 'クレジットカードの有効期限が切れています。',
  'invalid': 'クレジットカード情報が正しくありません。',
  'INVALID_CARD': 'クレジットカード情報が正しくありません。',
  'token': 'カード情報の処理に失敗しました。もう一度お試しください。'
};